/**
 * @file Chatbot routes generators
 */

import {
  ROUTE__CHATBOT_LULU,
  ROUTE__MORE,
} from '../../constants/routing/routes';

import { createDashboardPath } from './dashboard';

/**
 * Generate a path for the chatbot Lulu page
 *
 * @returns The generated path
 */
export const createChatbotLuluPath = (): string => {
  return `${createDashboardPath()}/${ROUTE__MORE}/${ROUTE__CHATBOT_LULU}`;
};
